import React from 'react';
import Truncate from 'react-truncate';

const BrandItem = (props) => {
  const {
    index,
    name,
    image,
    handleBanner,
  } = props;

  return (
    <div className="carousel-item" onMouseEnter={() => handleBanner(index)} onTouchStart={() => handleBanner(index)}>
      <a href={`#${name}`} className="overlay">
        <Truncate lines={2} ellipsis={<span>...</span>}>
          {name}
        </Truncate>
      </a>
      <img src={image} alt={name} />
    </div>
  );
};

export default BrandItem;



// WEBPACK FOOTER //
// ./src/components/products-list/brand-item.jsx